import {ModuleComponent} from "../../js/module-component";
import {GvfService} from "../../../gvf/js/gvf-service";
import Swal from "sweetalert2";

export class ModWebUserSetPass extends ModuleComponent{
    ready(){
        super.ready();
        const $form = this.findMember("form");
        $form.submit(
            (ev) => {
                ev.preventDefault();

                $form.checkRestrictions().then(
                    (isOk) => {
                        if(isOk){
                            GvfService.endpoint("/web/web-user/set-pass",{formData:$form.getValues()}).then(
                                (resp) => {
                                    this.$root.addClass("is-confirmed");
                                }
                            ).catch(
                                (err)=>{
                                    Swal.fire({
                                        title: "Error",
                                        text: err && err.hasOwnProperty("responseJSON") && err.responseJSON?err.responseJSON.message:"",
                                    });
                                }
                            );
                        }
                    }
                );
            }
        );
    }
}
